<h3>{{ 'ADMIN.SAP_UPDATE.HEADLINE' | translate }}</h3>

<p class="description">
  {{ 'ADMIN.SAP_UPDATE.DESCRIPTION' | translate }}
</p>
<div class="row gap">
  <div class="col-6 download">
    <div>
      <h3 class="download-title">{{ 'ADMIN.SAP_UPDATE.DOWNLOAD.HEADING' | translate }}</h3>
      <p class="cx-file-uploader-description">{{ 'ADMIN.SAP_UPDATE.DOWNLOAD.DESCRIPTION' | translate }}</p>
        <a hpmSecureDownload [url]="getEndpoint()" fileName="sapSpecialtyMapping.json">
        <button color="accent" mat-flat-button>
          {{ 'ADMIN.SAP_UPDATE.DOWNLOAD.BUTTON' | translate }}
        </button>
      </a>
    </div>
  </div>
  <div class="col-6">
    <hpm-file-uploader
      [endpoint]="getEndpoint()"
      [multiple]="false"
      acceptedFileTypes="application/json"
      buttonText="{{ 'ADMIN.SAP_UPDATE.UPLOAD.BUTTON' | translate }}"
      description="{{ 'ADMIN.SAP_UPDATE.UPLOAD.DESCRIPTION' | translate }}"
      errorMessage="{{ 'ADMIN.SAP_UPDATE.UPLOAD.ERROR_MESSAGE' | translate }}"
      heading="{{ 'ADMIN.SAP_UPDATE.UPLOAD.HEADING' | translate }}">
    </hpm-file-uploader>
  </div>
</div>
